import { render } from "./Recommender.vue?vue&type=template&id=79efc16e&scoped=true"
import script from "./Recommender.vue?vue&type=script&lang=js"
export * from "./Recommender.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Recommender.vue?vue&type=style&index=1&id=79efc16e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79efc16e"

export default script